import { useTranslation } from 'react-i18next';
import { Select as SelectNew } from 'components/NewSelect';
import { HealthRemoteControlFieldContainer, FieldHelpText } from './styles';

type HealthOption = { name: string; value: boolean };

type HealthRemoteControlFieldProps = {
  // null enquanto o valor salvo não chega de get-unit-info: o select fica travado.
  value: boolean | null;
  onChange: (visible: boolean) => void;
};

// Campo "Saúde no Controle Inteligente" do formulário de unidade: o valor de negócio é o booleano da opção.
export function HealthRemoteControlField({ value, onChange }: Readonly<HealthRemoteControlFieldProps>): JSX.Element {
  const { t } = useTranslation();
  const options: HealthOption[] = [
    { name: t('habilitada'), value: true },
    { name: t('desabilitada'), value: false },
  ];

  return (
    <HealthRemoteControlFieldContainer>
      <SelectNew
        style={{ margin: '10px 0px 4px 0px', width: '300px', height: '50px' }}
        options={options}
        propLabel="name"
        value={options.find((option) => option.value === value) ?? null}
        label={t('saudeNoControle')}
        notNull
        onSelect={(option: HealthOption) => onChange(option.value)}
        disabled={value == null}
        data-test-id="selectSaudeNoControle"
      />
      <FieldHelpText>{t('exibeIndicadorSaudeMaquinasControleInteligente')}</FieldHelpText>
    </HealthRemoteControlFieldContainer>
  );
}
